import { BACKGROUND_COLOR } from "../common/colors";

export const appStyle = {
  container: {
    flex: 1,
    backgroundColor: BACKGROUND_COLOR,
  },
};
